<template>
  <main class="dashboard">
        <div class="d-flex pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">{{current_page.name}}</h1>
    </div>
    <div class="text" v-html="current_page.description"></div>

    <div class="table-flex-responsive">
            <div class="row header">
              <div class="col-1"> №</div>
              <div class="col-lg-3">Ссылка на аккаунт в соц сети</div>
              <div class="col-3">Текст поста </div>
              <div class="col">Изображение или видео</div>
              <div class="col">Дата добавления / изменения</div>
              <div class="col"></div>
            </div>
            <template v-for="(object, index) in objects">

              <div class="row line">

                <div class="col-1 number"><div class="sub-head">№</div>{{ (index + 1) + ((page - 1) * size) }}</div>
                <div class="col sub-head">Ссылка на аккаунт в соц сети</div>
                <div class="col-lg-3 break-anyway">
                 <template v-if="object.edit">
                   <div :class="object.link_error?'form-group--error':''">
                       <label class="d-none">Ссылка на аккаунт в соц сети</label>
                      <input class="form-control" v-focus type="url" v-model="object.link"
                             v-on:keyup="object.link_error = false">
                    </div>
                    <div class="error" v-if="object.link_error">{{object.link_error}}</div>
                 </template>
                 <template v-else>
                   <a :href="object.link" target="_blank" class="break-anyway">{{object.link}}</a>
                 </template>
                </div>
                <div class="col sub-head">Текст поста </div>
                <div class="col-3">
                   <template v-if="object.edit">
                   <div :class="object.text_error?'form-group--error':''">
                       <label class="d-none">Текст поста</label>
                      <textarea class="form-control" name="" cols="50" rows="10"
                                v-on:keyup="object.text_error = false"
                                v-model="object.text"></textarea>
                    </div>
                    <div class="error" v-if="object.text_error">{{object.text_error}}</div>
                   </template>
                   <template v-else>
                     {{object.text}}
                   </template>
                </div>
                <div class="col sub-head">Изображение или видео</div>
                <div class="col">
                  <template v-if="object.edit">
                   <label class="d-none">Изображение или видео</label>
                    <div :class="'d-flex no-wrap'+(object.media_error?' form-group--error':'')">
                      <!--$func.setValue(object, 'media', false)-->

                      <input :id="`media-${index}`" :ref="`media-${index}`" type="file" class="d-none"
                             v-on:change="setFile('media', index, object)"/>
                      <input readonly type="text" :ref="`media_name-${index}`" class="file-name-upload"
                             v-on:change="object.media_error = false" v-model="object.media"/>
                      <label class="btn btn-primary" :for="`media-${index}`" title="Загрузить"><i
                        class="bi bi-file-arrow-up"></i></label>
                      <label class="btn btn-danger" v-if="object.media" v-on:click="object.media = ''" title="Удалить"><i class="bi bi-x"></i></label>
                    </div>
                    <div class="error" v-if="object.media_error">{{object.media_error}}</div>
                   </template>
                   <template v-else>
                     {{object.media}}
                   </template>
                </div>
                <div class="col sub-head">Дата добавления / изменения</div>
                <div class="col">{{object.date}}</div>
                <div class="col sub-head"></div>
                <div class="col">
                  <a href="" v-if="!object.edit" v-on:click.prevent="object.edit = true;"
                     class="no-wrap"><i class="bi bi-pencil"></i>
                    <small>редактировать</small>
                  </a>
                  <template v-else>
                    <a href="" class="text-success ms-sm-2 no-wrap d-block" v-on:click.prevent="saveNote(object)"><i
                      class="bi bi-check-circle"></i>
                      <small>Сохранить</small>
                    </a>
                    <a href="" class="text-danger ms-sm-2 no-wrap d-block mt-2" v-on:click.prevent="endEdit(object)"><i
                      class="bi bi-x-circle"></i>
                      <small>Отмена</small>
                    </a>
                  </template>
                </div>
              </div>
            </template>
            <div v-if="!objects.length" class="row">
              <div  class="col-12 text-center">
                Не добавлено ни одной записи
              </div>
            </div>
            <div v-if="objects.length < max_length">
              <div>
                <button class="btn btn-success" v-on:click="addNote" title="Добавить запись">+</button>
              </div>
            </div>
            </div>

    <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page" ></PagerList>


  </main>
</template>

<script>
  import dataMixin from './mixins.js';

  export default {
    name: 'SocialsService',
    mixins: [dataMixin],
    data() {
      return {
        name: 'socials',
        empty: {link: '', text: '', date: '', edit: true, media: ''},
        validate: {
          link: {func: (o) => {return !o.link || !this.$func.isURL(o.link)}, error: 'Неверный формат ссылки'},
          text: {},
        }
      }
    }
  }

</script>

<style>
  textarea {
    min-width: 380px;
  }
</style>
